/* BAZIC storefront behaviour.
   Ported from the design prototype's React component to plain JS so it runs
   inside a Shopify theme with no framework and no build step. */
(function () {
  'use strict';
  var body = document.body;
  var D = body.dataset;
  var ROOT = D.bzRoot || '/';
  var SEARCH_URL = D.bzSearch || '/search';
  var COLLECTIONS = D.bzCollections || '/collections';
  var MONEY = D.bzMoney || '${{amount}}';

  function money(cents) {
    var n = (Number(cents) / 100);
    var s = n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return MONEY.replace(/\{\{\s*amount[^}]*\}\}/, s);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function show(el, on) { if (el) { if (on) el.removeAttribute('hidden'); else el.setAttribute('hidden', ''); } }
  function mq(q) { try { return !!(window.matchMedia && window.matchMedia(q).matches); } catch (e) { return false; } }
  function reduceMotion() { return mq('(prefers-reduced-motion: reduce)'); }
  function hasHover() { return mq('(hover: hover)'); }
  function safe(label, fn) { try { fn(); } catch (e) { console.error('[bazic] ' + label, e); } }

  /* ------------------------------------------------------ mega menu data */
  var MENU_LINKS = {"Packaging Tape":"tape-packaging","Masking Tape":"tape-masking","Stationery Tape":"tape-stationery","Duct Tape":"tape-duct","Tape Dispensers":"tape-dispenser","Safety Tape":"tape-safety","Project Glue":"adhesives-project","Pencil Accessories":"pencils-accessory-1","Highlighters":"highlighters","Glue Sticks":"adhesives-school","Glue":"adhesives-project","Book Cover":"book-cover","Book Rings":"book-rings-1","Geometry - Compass":"geometry-compass","Labels - Stickers":"labels-stickers-1","Frames":"frames","Key Chains":"key-chain","Stencils":"stencil-1","Index Cards":"index-card","Safety":"tape-safety","Crayons":"crayons","Correction":"correction","Erasers":"erasers","Mechanical Pencils":"pencils-mechanical-1","Sharpeners":"sharpeners","Wood Pencils":"pencils-wood-1","Flash Cards":"flash-cards","Sticky Flags":"sticky-notes-flags-1","Sticky Pads":"sticky-notes-pads-1","Binders - 3 Ring":"binders-3-ring","Binders - Inserts":"binders-inserts","Binder Clips":"binder-clips","Clipboards":"clipboards","Folders & Portfolios":"folders-portfolios","Organizer":"organizer","Calculator":"calculators","Calculators":"calculators","Geometry - Set":"geometry-set","Geometry - Ruler":"geometry-ruler","Paper Punch":"paper-punches","Scissors":"scissors","Staplers":"staplers","Writing Boards":"writing-boards","Backpacks":"backpack","Locker Accessories":"locker-accessories","School Kits":"school-kit","Calendar":"calendars","Labels - Mailing":"labels-mailing-1","Labels - Projects":"labels-projects","Sticky Notes - Flags":"sticky-notes-flags-1","Sticky Notes - Pads":"sticky-notes-pads-1","Binder - 3 Ring":"binders-3-ring","Clips & Pins":"clips-pins","Document Organizer":"document-organizer","Desk Organizer":"desk-organizer","Business Form":"business-form","Coin Wrappers":"coin-wrappers","Envelopes & Mailers":"envelopes-mailers","Signage":"signage","Stamp":"stamp","Dispenser":"tape-dispenser","Double Sided":"tape-double-sided","Duct":"tape-duct","Masking":"tape-masking","Packaging":"tape-packaging","Stationery":"tape-stationery","Cutters":"cutters-1","Magnifiers":"magnifiers","Rubber Bands":"rubber-bands","Canvas":"canvas","Paint & Brush":"paint-brush","Chalk":"chalk","Art Clay & Dough":"art-clay-dough","Arts & Crafts Paper":"arts-crafts-paper","Craft Accessories":"craft-accessories","Double Sided Tape":"tape-double-sided","Art Project Tape":"tape-art-project","Glitter":"glitter","Display Rack":"display-rack","Presentation Boards":"presentation-boards","Books - Activity":"books-activity","Books - Educational":"books-educational","Books - Puzzle":"books-puzzle","Copy Paper":"copy-paper","Writing & Memo Pad":"writing-memo-pad","Notebook & Filler":"notebook-filler-1","All Highlighters":"highlighters","Art Markers":"markers-art-1","Coloring Markers":"markers-coloring-1","Dry Erase Markers":"markers-dry-erase-1","Permanent Markers":"markers-permanent","Specialty Markers":"markers-specialty","Accessories":"pencils-accessory-1","Wood Free Pencils":"pencils-wood-free-1","Ballpoint":"pens-ballpoint-1","Fiber Tip":"pens-fiber-tip-1","Fuse Tech Ink":"pens-fuse-tech-ink-1","Gel Ink":"pens-gel-ink-1","Rollerball":"pens-roller-1", "Board Books":"board-books", "Story Books":"story-books", "Work Books":"work-books", "Coloring - Licensed":"coloring-licensed", "Coloring - Non-Licensed":"coloring-non-licensed", "Coloring - Adult":"coloring-adult", "Word Finds":"word-finds", "Digest Word Finds":"digest-word-finds", "Sudoku":"sudoku", "Digest Sudoku":"digest-sudoku", "Crosswords":"crosswords", "Games":"games", "Sopa De Letras - Spanish":"sopa-de-letras-spanish", "Display Towers":"display-towers"};
  var MENUS = {
  school: [
    { title: "Backpacks & Kits", items: ["Backpacks", "Locker Accessories", "School Kits"] },
    { title: "Binders & Folders", items: ["Binders - 3 Ring", "Binders - Inserts", "Book Cover", "Book Rings", "Folders & Portfolios"] },
    { title: "Classroom Supplies", items: ["Clipboards", "Flash Cards", "Glue Sticks", "Scissors", "Writing Boards"] },
    { title: "Displays & Kits", items: ["Display Towers", "School Kits"] },
    { title: "Erasers & Correction", items: ["Correction", "Erasers", "Sharpeners"] },
    { title: "Math & Geometry", items: ["Calculators", "Geometry - Compass", "Geometry - Ruler", "Geometry - Set"] },
    { title: "Sticky Notes & Labels", items: ["Labels - Projects", "Labels - Stickers", "Sticky Notes - Flags", "Sticky Notes - Pads"] }
  ],
  office: [
    { title: "Desk Tools", items: ["Calculators", "Cutters", "Magnifiers", "Paper Punch", "Rubber Bands", "Staplers"] },
    { title: "Displays", items: ["Display Towers"] },
    { title: "Filing & Organization", items: ["Binder Clips", "Binders - 3 Ring", "Binders - Inserts", "Clipboards", "Clips & Pins", "Document Organizer", "Desk Organizer", "Folders & Portfolios", "Organizer"] },
    { title: "Mailing & Shipping", items: ["Coin Wrappers", "Envelopes & Mailers", "Labels - Mailing", "Stamp"] },
    { title: "Notes & Labels", items: ["Labels - Projects", "Labels - Stickers", "Sticky Notes - Flags", "Sticky Notes - Pads"] },
    { title: "Signage & Display", items: ["Calendar", "Frames", "Key Chains", "Signage", "Writing Boards"] },
    { title: "Tape & Adhesives", items: ["Double Sided Tape", "Duct Tape", "Masking Tape", "Packaging Tape", "Safety Tape", "Stationery Tape", "Tape Dispensers"] }
  ],
  arts: [
    { title: "Clay, Glitter & Embellishments", items: ["Art Clay & Dough", "Craft Accessories", "Glitter"] },
    { title: "Craft Paper & Adhesives", items: ["Art Project Tape", "Arts & Crafts Paper", "Project Glue", "Stencils"] },
    { title: "Display & Presentation", items: ["Display Rack", "Presentation Boards"] },
    { title: "Painting & Drawing", items: ["Canvas", "Chalk", "Crayons", "Paint & Brush"] }
  ],
  paper: [
    { title: "Cards & Index", items: ["Flash Cards", "Index Cards"] },
    { title: "Forms & Envelopes", items: ["Business Form", "Envelopes & Mailers"] },
    { title: "Paper & Pads", items: ["Copy Paper", "Notebook & Filler", "Presentation Boards", "Writing & Memo Pad"] },
    { title: "Sticky Notes & Labels", items: ["Labels - Projects", "Labels - Stickers", "Sticky Notes - Flags", "Sticky Notes - Pads"] }
  ],
  writing: [
    { title: "Pens", items: ["Ballpoint", "Fiber Tip", "Fuse Tech Ink", "Gel Ink", "Rollerball"] },
    { title: "Pencils", items: ["Mechanical Pencils", "Pencil Accessories", "Wood Free Pencils", "Wood Pencils"] },
    { title: "Markers & Highlighters", items: ["Art Markers", "Coloring Markers", "Dry Erase Markers", "Highlighters", "Permanent Markers", "Specialty Markers"] },
    { title: "Erasers & Correction", items: ["Correction", "Erasers", "Sharpeners"] },
  ],
  beyondbazic: [
    { title: "Books - Activity", items: ["Coloring - Licensed", "Coloring - Non-Licensed", "Coloring - Adult"] },
    { title: "Books - Educational", items: ["Board Books", "Story Books", "Work Books"] },
    { title: "Books - Puzzle", items: ["Word Finds", "Digest Word Finds", "Sudoku", "Digest Sudoku", "Crosswords", "Games", "Sopa De Letras - Spanish"] }
  ]
};
  var MENU_BASE = COLLECTIONS.replace(/\/$/, '') + '/';

  /* ================================================== header: mega menu */
  var nav = document.querySelector('[data-bz-onmouseleave="closeMenu"]');
  var panel = nav && nav.querySelector('[data-bz-show="panelOpen"]');
  var panelCols = nav && nav.querySelector('[data-bz-panelcols]');
  var megaOn = nav ? nav.getAttribute('data-bz-mega') !== 'false' : false;

  // window.BZ_TITLE_LINKS = {"Books - Activity": "books-activity", "Books - Educational": "books-educational", "Books - Puzzle": "books-puzzle", "Displays & Kits": "displays-kits", "Displays": "displays", "Backpacks & Kits": "backpacks-kits", "Binders & Folders": "binders-folders", "Classroom Supplies": "classroom-supplies", "Erasers & Correction": "erasers-correction", "Math & Geometry": "math-geometry", "Sticky Notes & Labels": "sticky-notes-labels", "Notes & Labels": "sticky-notes-labels", "Desk Tools": "desk-tools", "Filing & Organization": "filing-organization", "Mailing & Shipping": "mailing-shipping", "Signage & Display": "signage-display", "Tape & Adhesives": "tape-adhesives", "Clay, Glitter & Embellishments": "clay-glitter-embellishments", "Craft Paper & Adhesives": "craft-paper-adhesives", "Display & Presentation": "display-presentation", "Painting & Drawing": "painting-drawing", "Cards & Index": "cards-index", "Forms & Envelopes": "forms-envelopes", "Paper & Pads": "paper-pads", "Pens": "pens", "Pencils": "pencils", "Markers & Highlighters": "markers-highlighters"}; window.BZ_MENUS = MENUS; window.BZ_MENU_LINKS = MENU_LINKS; function renderPanel(key) {
  //   if (!panel || !panelCols || !megaOn || !MENUS[key]) return;
  //   panelCols.innerHTML = MENUS[key].map(function (c) {
  //     var items = c.items.map(function (n) {
  //       var it = { name: n, url: MENU_LINKS[n] ? MENU_BASE + MENU_LINKS[n] : MENU_BASE.replace(/\/$/, '') };
  //       return `<a class="bz-4f5c7b9" href="${it.url}">${it.name}</a>`;
  //     }).join('');
  //     return `<div class="bz-3e4caca">
  //           <div class="bz-fe9e6b0">${esc(c.title)}</div>
  //           ${items}
  //         </div>`;
  //   }).join('');
  //   show(panel, true);
  // }

  window.BZ_TITLE_LINKS = {"Books - Activity": "books-activity", "Books - Educational": "books-educational", "Books - Puzzle": "books-puzzle", "Displays & Kits": "displays-kits", "Displays": "displays", "Backpacks & Kits": "backpacks-kits", "Binders & Folders": "binders-folders", "Classroom Supplies": "classroom-supplies", "Erasers & Correction": "erasers-correction", "Math & Geometry": "math-geometry", "Sticky Notes & Labels": "sticky-notes-labels", "Notes & Labels": "sticky-notes-labels", "Desk Tools": "desk-tools", "Filing & Organization": "filing-organization", "Mailing & Shipping": "mailing-shipping", "Signage & Display": "signage-display", "Tape & Adhesives": "tape-adhesives", "Clay, Glitter & Embellishments": "clay-glitter-embellishments", "Craft Paper & Adhesives": "craft-paper-adhesives", "Display & Presentation": "display-presentation", "Painting & Drawing": "painting-drawing", "Cards & Index": "cards-index", "Forms & Envelopes": "forms-envelopes", "Paper & Pads": "paper-pads", "Pens": "pens", "Pencils": "pencils", "Markers & Highlighters": "markers-highlighters"}; window.BZ_MENUS = MENUS; window.BZ_MENU_LINKS = MENU_LINKS; function renderPanel(key) {
  if (!panel || !panelCols || !megaOn || !MENUS[key]) return;

  panelCols.innerHTML = MENUS[key].map(function (c) {

    var items = c.items.map(function (n) {
      var it = {
        name: n,
        url: MENU_LINKS[n]
          ? MENU_BASE + MENU_LINKS[n]
          : MENU_BASE.replace(/\/$/, '')
      };

      return `<a class="bz-4f5c7b9" href="${it.url}">${esc(it.name)}</a>`;
    }).join('');

    var clickableTitles = window.BZ_TITLE_LINKS || {
      "Books - Activity": "books-activity",
      "Books - Educational": "books-educational",
      "Books - Puzzle": "books-puzzle",
      "Displays & Kits": "displays-kits",
      "Displays": "displays"
    };

    var titleHtml;

    if (clickableTitles[c.title]) {
      titleHtml = `<a class="bz-fe9e6b0 bz-4f5c7b9" href="${MENU_BASE}${clickableTitles[c.title]}">${esc(c.title)}</a>`;
    } else {
      titleHtml = `<div class="bz-fe9e6b0">${esc(c.title)}</div>`;
    }

    return `<div class="bz-3e4caca">
      ${titleHtml}
      ${items}
    </div>`;

  }).join('');

  show(panel, true);
}

  function closeMenu() { show(panel, false); }

  if (nav) {
    var KEYS = { openSchool: 'school', openOffice: 'office', openArts: 'arts',
                 openPaper: 'paper', openWriting: 'writing', openBeyondBAZIC: 'beyondbazic' };
    nav.querySelectorAll('[data-bz-onmouseenter]').forEach(function (a) {
      var h = a.getAttribute('data-bz-onmouseenter');
      a.addEventListener('mouseenter', function () {
        if (KEYS[h]) renderPanel(KEYS[h]); else closeMenu();
      });
    });
    nav.querySelectorAll('[data-bz-onmouseenter]').forEach(function (a) {
      var h = a.getAttribute('data-bz-onmouseenter');
      if (!KEYS[h]) return;
      a.addEventListener('focus', function () { renderPanel(KEYS[h]); });
      a.addEventListener('click', function (e) {
        if (hasHover()) return;               // desktop already opened it on hover
        if (panel && panel.hasAttribute('hidden')) { e.preventDefault(); renderPanel(KEYS[h]); }
      });
    });
    nav.addEventListener('mouseleave', closeMenu);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });
  }

  /* ============================================ header: search + suggest */
  var form = document.querySelector('form[data-bz-onsubmit="doSearch"]');
  if (form) {
    var input = form.querySelector('input[name="q"]');
    var scopeSel = form.querySelector('select');
    var sugBox = form.querySelector('[data-bz-show="sugOpen"]');
    var sugList = form.querySelector('[data-bz-suglist]');
    var noRes = form.querySelector('[data-bz-show="noResults"]');
    var allLink = form.querySelector('[data-bz-allresults]');
    var qEcho = form.querySelector('[data-bz-query]');
    var suggestOn = form.getAttribute('data-bz-suggest') !== 'false';
    var timer = null, token = 0;

    form.setAttribute('action', SEARCH_URL);
    form.setAttribute('method', 'get');
    var typeField = document.createElement('input');
    typeField.type = 'hidden'; typeField.name = 'type'; typeField.value = 'product';
    form.appendChild(typeField);

    function scope() {
      var v = scopeSel ? scopeSel.value : '';
      return (v && v !== 'All Categories') ? v : '';
    }
    function searchUrl(q) {
      var s = scope();
      return q ? SEARCH_URL + '?q=' + encodeURIComponent((s ? s + ' ' : '') + q) + '&type=product'
               : COLLECTIONS;
    }
    function paint(list, q) {
      if (!sugList) return;
      sugList.innerHTML = list.map(function (p) { return `
            <a class="bz-fef12a8" href="${p.url}">
              <span class="bz-2f70ea5" style="--bz-thumb:url(${p.img})"></span>
              <span class="bz-d6ab105">
                <span class="bz-3a310ca">${p.name}</span>
                <span class="bz-8832a79">${p.sku ? 'SKU ' + p.sku + ' · ' : ''}${p.cat}</span>
              </span>
              ${p.isNew ? '<span class="bz-sugnew">New</span>' : ''}<span class="bz-9f4c323">${p.price}</span>
            </a>
          `; }).join('');
      show(noRes, list.length === 0);
      if (allLink) allLink.setAttribute('href', searchUrl(q));
      if (qEcho) qEcho.textContent = q;
      show(sugBox, true);
    }
    function fallback(q) {
      var api = window.BZ_PRODUCTS;
      if (!api) return [];
      return api.suggest(q, scopeSel ? scopeSel.value : '', 6).map(function (p) {
        return { url: ROOT + 'products/' + p.url.split('/products/')[1],
                 img: p.img, name: p.name, sku: p.sku, cat: p.cat, price: p.price };
      });
    }
    function deepLookup(q, mine) {
      var u = SEARCH_URL + '?view=suggest&type=product&q=' + encodeURIComponent(q);
      fetch(u, { headers: { Accept: 'text/plain' } })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (t) { if (mine !== token) return; var list; try { list = JSON.parse(t); } catch (e) { list = fallback(q); } var sc = scope(); if (sc === 'Arts & Crafts') sc = 'Art Supplies'; if (sc) { var f = list.filter(function (p) { return (p.cols || []).indexOf(sc) !== -1; }); if (f.length) list = f; } paint(list.slice(0, 6), q); })
        .catch(function () { if (mine === token) paint(fallback(q), q); });
    }
    function lookup(raw) {
      var q = (raw || '').trim();
      if (!q || !suggestOn) { show(sugBox, false); return; }
      var mine = ++token;
      var s = scope();
      var url = SEARCH_URL + '/suggest.json?q=' + encodeURIComponent((s ? s + ' ' : '') + q) +
                '&resources[type]=product&resources[limit]=6';
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function (data) {
          if (mine !== token) return;
          var items = (((data.resources || {}).results || {}).products || []).map(function (p) {
            var v = (p.variants && p.variants[0]) || {};
            var price = p.price != null ? p.price : v.price;
            var shown = typeof price === 'number' ? money(price)
                      : (/^[\d.,]+$/.test(String(price || '')) ? money(Number(price) * 100) : String(price || ''));
            return { url: p.url, img: p.featured_image ? p.featured_image.url : (p.image || ''),
                     name: p.title, sku: v.sku || '', cat: p.type || '', price: shown, isNew: (p.tags || []).join(',').toUpperCase().indexOf('NEW ITEMS') > -1 };
          });
          if (items.length) paint(items, q); else deepLookup(q, mine);
        })
        .catch(function () { if (mine === token) deepLookup(q, mine); });
    }

    if (input) {
      var onType = function (e) {
        clearTimeout(timer);
        var v = e.target.value;
        timer = setTimeout(function () { lookup(v); }, 140);
      };
      input.addEventListener('input', onType);
      input.addEventListener('focus', onType);
      input.addEventListener('blur', function () { setTimeout(function () { show(sugBox, false); }, 160); });
      input.addEventListener('keydown', function (e) { if (e.key === 'Escape') show(sugBox, false); });
    }
    if (scopeSel) scopeSel.addEventListener('change', function () { if (input) lookup(input.value); });
    form.addEventListener('submit', function (e) {
      var q = (input && input.value || '').trim();
      if (!q) { e.preventDefault(); window.location.href = COLLECTIONS; return; }
      show(sugBox, false);
    });
  }

  /* ============================================ New Arrivals moving belt */
  safe('belt', function () {
  var belt = document.querySelector('[data-bz-newrow]');
  if (belt && belt.children.length) {
    var nudge = 0, paused = false;
    Array.prototype.slice.call(belt.children).forEach(function (n) {
      var c = n.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.setAttribute('tabindex', '-1');
      c.querySelectorAll('a,button').forEach(function (el) { el.setAttribute('tabindex', '-1'); });
      belt.appendChild(c);
    });
    belt.addEventListener('mouseenter', function () { paused = true; });
    belt.addEventListener('mouseleave', function () { paused = false; });
    belt.addEventListener('focusin', function () { paused = true; });
    belt.addEventListener('focusout', function () { paused = false; });
    document.querySelectorAll('[data-bz-onclick="newPrev"]').forEach(function (b) {
      b.addEventListener('click', function () { nudge -= belt.clientWidth * 0.8; });
    });
    document.querySelectorAll('[data-bz-onclick="newNext"]').forEach(function (b) {
      b.addEventListener('click', function () { nudge += belt.clientWidth * 0.8; });
    });
    var slow = reduceMotion();
    var last = performance.now(), SPEED = 26;
    (function step(now) {
      if (!belt.isConnected) return;
      var dt = Math.min(0.05, (now - last) / 1000);
      last = now;
      var half = belt.scrollWidth / 2, x = belt.scrollLeft;
      if (nudge) {
        var take = nudge * Math.min(1, dt * 7);
        x += take; nudge -= take;
        if (Math.abs(nudge) < 0.5) nudge = 0;
      } else if (!paused && !slow) {
        x += SPEED * dt;
      }
      if (x >= half) x -= half;
      if (x < 0) x += half;
      belt.scrollLeft = x;
      requestAnimationFrame(step);
    })(last);
  }

  });

  /* ================================================= Bay-Z eye tracking */
  safe('mascot', function () {
  var svg = document.getElementById('bayz-svg');
  if (svg && !reduceMotion()) {
    window.addEventListener('mousemove', function (e) {
      var b = svg.getBoundingClientRect();
      if (!b.width) return;
      var cx = b.left + b.width / 2, cy = b.top + b.height * 0.42, max = 34;
      var dx = Math.max(-1, Math.min(1, (e.clientX - cx) / (b.width * 0.9)));
      var dy = Math.max(-1, Math.min(1, (e.clientY - cy) / (b.height * 0.9)));
      svg.style.setProperty('--bz-px', (dx * max).toFixed(1) + 'px');
      svg.style.setProperty('--bz-py', (dy * max * 0.7).toFixed(1) + 'px');
    }, { passive: true });
  }

  });

  /* =============================================== product image thumbs */
  var hero = document.getElementById('bz-pdp-img');
  if (hero) {
    document.querySelectorAll('[data-bz-thumb]').forEach(function (b) {
      b.addEventListener('click', function () { hero.src = b.getAttribute('data-bz-thumb'); });
    });
  }

  /* ============================================== add to cart (ajax) */
  var counters = document.querySelectorAll('[data-bz-cartcount]');
  function setCount(n) {
    counters.forEach(function (el) { el.textContent = n; });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-bz-add]') : null;
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-bz-add');
    if (!id || btn.disabled) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding\u2026';
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function () { return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCount(cart.item_count);
        btn.setAttribute('data-bz-added', '');
        btn.textContent = 'Added \u2713';
        setTimeout(function () {
          btn.removeAttribute('data-bz-added');
          btn.textContent = label;
          btn.disabled = false;
        }, 1600);
      })
      .catch(function () {
        btn.textContent = 'Try again';
        btn.disabled = false;
        setTimeout(function () { btn.textContent = label; }, 1800);
      });
  });
})();
